(() => {
  const hydrateMobileMenuCards = () => {
    const template = document.querySelector('[data-mobile-menu-cards-template]');
    const targets = document.querySelectorAll('[data-mobile-menu-cards-target], [data-mega-menu-cards-target]');

    if (!(template instanceof HTMLTemplateElement) || targets.length === 0) return;

    const cards = [...template.content.children];
    const globalCards = cards.filter((card) => !card.dataset.menuCardFor);
    const maxOwnCards = 3;

    targets.forEach((target) => {
      const key = target instanceof HTMLElement ? target.dataset.menuKey || '' : '';
      const strict = target.hasAttribute('data-menu-cards-strict');
      const ownCards = key ? cards.filter((card) => card.dataset.menuCardFor === key).slice(0, maxOwnCards) : [];
      const selected = ownCards.length > 0 ? ownCards : strict ? [] : globalCards;
      const signature = selected.map((card) => card.outerHTML).join('');

      if (target.getAttribute('data-menu-cards-signature') === signature) return;

      target.setAttribute('data-menu-cards-signature', signature);
      target.replaceChildren(...selected.map((card) => card.cloneNode(true)));
    });

    const mobileTarget = document.querySelector('[data-mobile-menu-cards-target]');
    const mobileContainer = document.querySelector('[data-mobile-menu-cards-container]');

    if (mobileTarget instanceof HTMLElement && mobileContainer instanceof HTMLElement) {
      mobileContainer.hidden = mobileTarget.children.length === 0;
    }
  };

  let hydrationQueued = false;
  const scheduleHydration = () => {
    if (hydrationQueued) return;

    hydrationQueued = true;
    queueMicrotask(() => {
      hydrationQueued = false;
      hydrateMobileMenuCards();
    });
  };

  new MutationObserver(scheduleHydration).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scheduleHydration, { once: true });
  document.addEventListener('shopify:section:load', scheduleHydration);
  scheduleHydration();
})();
